import i18n from "@/components/I18n";
// 图表label
const PIECHAR_TYPE = {
  posts: i18n.t("baseInfo.posts"), //"声量",
  interaction: i18n.t("baseInfo.interaction"),
  reposts: i18n.t("baseInfo.reposts"),
  comments: i18n.t("baseInfo.comments"),
  zans: i18n.t("baseInfo.zans"),
};

//平台类型
const PLANT_TYPE = {
  xhs: i18n.t("mainHead.platList_xhs"), //"声量",
  weibo: i18n.t("mainHead.platList_weibo"),
  douyin: i18n.t("mainHead.platList_douyin"),
};

// 原文链接地址
const POST_LINK = {
  xhs: "https://www.xiaohongshu.com/discovery/item/",
  weibo: "https://m.weibo.cn/status/",
  douyin: "https://www.douyin.com/video/",
  cem: "https://pm.mktindex.com/issues/",
};

//人群画像
const PORTRAIT_TYPE = {
  man: i18n.t("baseInfo.man"),
  woman: i18n.t("baseInfo.woman"),
  users: i18n.t("baseInfo.users"),
  tgi: i18n.t("baseInfo.tgi"),
};
export { PLANT_TYPE, PIECHAR_TYPE, POST_LINK, PORTRAIT_TYPE };
